<mat-card [formGroup]="formGroup">
  <mat-card-header>
    <mat-card-title>Attachment</mat-card-title>
    <button
      mat-icon-button
      (click)="handleRemoveAttachment()"
      type="button"
      matTooltip="Remove attachment"
    >
      <mat-icon>delete</mat-icon>
    </button>
  </mat-card-header>
  <mat-card-content fxLayout="column" fxLayoutGap="16px">
    <mat-form-field>
      <mat-label>Format</mat-label>
      <input matInput formControlName="format" />
      @if (formGroup.get('format')?.hasError('required')) {
        <mat-error> Format is required </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Data</mat-label>
      <input matInput formControlName="data" />
      @if (formGroup.get('data')?.hasError('required')) {
        <mat-error> Data is required </mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Credential IDs</mat-label>
      <mat-chip-grid formControlName="credential_ids" #chipList>
        @for (credId of credentialIds(); track credId; let j = $index) {
          <mat-chip-row [removable]="true" (removed)="removeCredentialId(j)">
            {{ credId }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip-row>
        }
        <input
          placeholder="New credential ID..."
          [matChipInputFor]="chipList"
          (matChipInputTokenEnd)="addCredentialId($event)"
        />
      </mat-chip-grid>
    </mat-form-field>
  </mat-card-content>
</mat-card>
